import { StyleSheet } from 'aphrodite';
import { THEME } from '../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		background: THEME.colors.background.light,
		boxSizing: 'border-box',
		display: 'flex',
		flex: 1,
		height: '100%',
		paddingLeft: THEME.spacing.md,
	},
	notFound: {
		display: 'block',
		marginTop: 30,
	},
	splitDetail: {
		borderLeft: THEME.common.border,
		// Named container for CompanyActivity's tab bar, which drops icons and labels as the column narrows.
		container: 'companyActivity / inline-size',
		flex: '1 0 0',
		height: '100%',
		overflowX: 'hidden',
	},
	splitMaster: {
		background: THEME.colors.background.light,
		boxSizing: 'border-box',
		flex: '0 0 420px',
		overflowY: 'auto',
		paddingBottom: 30,
		paddingRight: 30,
		paddingTop: 50,
	},
});
